import React, { Component } from 'react'
import SectionTitleOne from './SectionTitleOne'
import Slider from 'react-slick'

const youtubeVideos = [
    'BNHvUnu7UwI',
    'RwhryOXi_V0',
    'MK1VX6Ei7Qg',
    'VDkdb8tnyHY',
    '5Nze_sBEby8',
    'pyebeKQePJw',
    'D4zaYVYir5E',
    '_mpyYfAwRvc',
    '9JX8E9bp8tY',
    '4KQaCuWGn1w',
    'kC0JGXLgXi4',
];

const WhitePrevArrow = ({ onClick }) => (
    <button className="news-arrow news-prev" onClick={onClick} style={{ color: '#fff' }}>←</button>
);

const WhiteNextArrow = ({ onClick }) => (
    <button className="news-arrow news-next" onClick={onClick} style={{ color: '#fff' }}>→</button>
);

const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <WhitePrevArrow />,
    nextArrow: <WhiteNextArrow />,
    responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 992,  settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 768,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true } },
        { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: true } },
    ],
};

class GalleryImage extends Component {
    render() {
        const images = [
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage01.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage02.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage03.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage04.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage05.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage06.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage07.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage08.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage09.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage10.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage11.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage12.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage13.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage14.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage15.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage16.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage17.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/GalleryImage18.jpg'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/01.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/03.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/04.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/05.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/06.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/08.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/10.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/11.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/13.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/14.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/15.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/18.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/19.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/20.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/21.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/22.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/23.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/24.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/25.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/26.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/27.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/28.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/29.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/30.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/31.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/32.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/33.webp'),
            require('../assets/img/whatsinaname/gallery/innerpage/NewImg/34.webp'),
        ];

        const videoItems = youtubeVideos.map(id => ({ type: 'video', id }));
        const imageItems = images.map((src, i) => ({ type: 'image', src, i }));
        const allItems = [...videoItems, ...imageItems];

        const chunk = (arr, n) => { const r = []; for (let i = 0; i < arr.length; i += n) r.push(arr.slice(i, i + n)); return r; };
        const desktopSlides = [...chunk(videoItems, 6), ...chunk(imageItems, 6)];
        const tabletSlides  = [...chunk(videoItems, 4), ...chunk(imageItems, 4)];

        const sliderSettings = {
            dots: true,
            infinite: true,
            autoplay: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: <WhitePrevArrow />,
            nextArrow: <WhiteNextArrow />,
        };

        const renderItem = (item, key) => {
            if (item.type === 'video') {
                return (
                    <div key={key} style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px' }}>
                        <iframe src={`https://www.youtube.com/embed/${item.id}`} title={`Video ${item.id}`} frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
                    </div>
                );
            }
            return <img key={key} src={item.src} alt={`gallery-${item.i + 1}`} style={{ width: '100%', borderRadius: '8px', display: 'block', aspectRatio: '16/9', objectFit: 'cover' }} />;
        };

        return (
            <section className="gallery-one-wrapper section-bg text-white section-padding vSleepDisorderBlock">
                <div className="hero-shape service-shape">
                    <img src={require("../assets/img/shape/rmc.png")} alt="donto" className="shape shape2" />
                    <img src={require("../assets/img/shape/plusgs.png")} alt="donto" className="shape shape4" />
                    <img src={require("../assets/img/shape/plusg.png")} alt="donto" className="shape shape6" />
                    <img src={require("../assets/img/shape/plusr.png")} alt="donto" className="shape shape8" />
                    <img src={require("../assets/img/shape/sgdot.png")} alt="donto" className="shape shape9" />
                    <img src={require("../assets/img/shape/xsrdot.png")} alt="donto" className="shape shape10" />
                    <img src={require("../assets/img/shape/rmc.png")} alt="donto" className="shape s1" />
                    <img src={require("../assets/img/shape/plusgs.png")} alt="donto" className="shape s2" />
                    <img src={require("../assets/img/shape/sgdot.png")} alt="donto" className="shape s3" />
                </div>
                <div className="container">
                    <SectionTitleOne BigTitle="A Look at Our World" />

                    {/* Desktop: 2×3 grid per slide */}
                    <div className="d-none d-lg-block" style={{ padding: '0 24px' }}>
                        <Slider {...sliderSettings}>
                            {desktopSlides.map((slide, si) => (
                                <div key={si}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                                        {slide.map((item, ii) => renderItem(item, ii))}
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Tablet: 2×2 grid per slide */}
                    <div className="d-none d-md-block d-lg-none" style={{ padding: '0 24px' }}>
                        <Slider {...sliderSettings}>
                            {tabletSlides.map((slide, si) => (
                                <div key={si}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                                        {slide.map((item, ii) => renderItem(item, ii))}
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Mobile: 1 per slide */}
                    <div className="d-md-none" style={{ padding: '0 24px' }}>
                        <Slider {...{...sliderSettings, dots: false}}>
                            {allItems.map((item, i) => (
                                <div key={i}>{renderItem(item, i)}</div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default GalleryImage
